import React from "react";
import BuyTittle from "./BuyTittle";

// Thin wrapper that reuses BuyTittle for new arrivals
export default function NewArrivalTittle() {
  return <BuyTittle model="newarrival" />;
}
